import {
  AudioLines,
  Boxes,
  ImagePlus,
  MessageCircle,
  Mic,
  Music,
  Palette,
  Video,
} from "lucide-react";
import { t } from "../../i18n";
import type { ComposerActivity } from "./Composer";

export const activityDetails = {
  ask: {
    icon: MessageCircle,
  },
  image: {
    icon: Palette,
  },
  audio: { icon: Music },
  video: { icon: Video },
  speech: { icon: Mic },
  transcription: { icon: AudioLines },
  model3d: { icon: Boxes },
  sprite: { icon: ImagePlus },
  tileset: { icon: Boxes },
} satisfies Record<ComposerActivity, { icon: typeof MessageCircle }>;

export function activityLabel(activity: Exclude<ComposerActivity, "ask">) {
  return activity === "image"
    ? t("Create image")
    : activity === "audio"
      ? t("Generate audio")
      : activity === "video"
        ? t("Create video")
        : activity === "speech"
          ? t("Generate speech")
          : activity === "transcription"
            ? t("Transcribe")
            : activity === "model3d"
              ? t("Create 3D model")
              : activity === "sprite"
                ? t("Create sprite")
                : t("Create tileset");
}

export function activityDisplayLabel(activity: ComposerActivity) {
  return activity === "ask" ? t("Ask") : activityLabel(activity);
}

export function activityDescription(activity: ComposerActivity) {
  switch (activity) {
    case "ask":
      return t("Chat, reason, and use tools");
    case "image":
      return t("Generate an image from a prompt");
    case "audio":
      return t("Generate music or other audio");
    case "video":
      return t("Generate a video from a prompt");
    case "speech":
      return t("Turn text into spoken audio");
    case "transcription":
      return t("Turn audio or video into text");
    case "model3d":
      return t("Generate a game-ready 3D asset");
    case "sprite":
      return t("Generate a sprite or sprite sheet");
    case "tileset":
      return t("Generate a terrain or tile atlas");
  }
}
